import { Component } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'pace-core-request-version-update',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './request-version-update.component.html',
    styleUrl: './request-version-update.component.scss',
})
export class RequestVersionUpdateComponent {
    public constructor(private modalService: BsModalService) {}

    public postponeUpdate(): void {
        this.modalService.hide();
    }

    public performUpdate(): void {
        window.location.reload();
    }
}
